import { get, isNil } from 'lodash';

import fetchIsGovernmentInsurance from './data/fetchIsGovernmentInsurance';
import fetchStateAndCost from './data/fetchStateAndCost';

import { getReferrerType } from '../../../utils/getReferrerType';
import { BOOKING_COMPLETE_GA_CATEGORY, GaActionText } from '../constants';

export async function updateGTMDataLayer(
    bookingState = {},
    allowGovernmentInsurance
) {
    if (window.dataLayer) {
        const {
            request_id: requestId,
            insurance_plan_id: insurancePlanId,
            provider_id: providerMonolithId,
            location_id: locationMonolithId,
            reschedule_request_id: rescheduleRequestId,
            referrer_type: referrerTypeFromBooking,
        } = bookingState;

        const isNewPatient = !get(bookingState, 'existing_patient', true);
        const isRescheduled = !isNil(rescheduleRequestId);
        const referrerType = referrerTypeFromBooking || getReferrerType();
        const baseGTMData = {
            event: `[${BOOKING_COMPLETE_GA_CATEGORY}] ${GaActionText.trackMadeItToBookingComplete}`,
            requestId: requestId,
            isNewPatient: isNewPatient,
            referrerType: referrerType,
            isRescheduled: isRescheduled,
        };

        const [isGovernmentInsurance, stateAndCostData] = await Promise.all([
            fetchIsGovernmentInsurance(
                insurancePlanId,
                allowGovernmentInsurance
            ),
            fetchStateAndCost(providerMonolithId, locationMonolithId),
        ]);

        const costPlanValue = get(stateAndCostData, 'costPlanValue', null);
        const stateCode = get(stateAndCostData, 'location.state', null);

        window.dataLayer.push({
            ...baseGTMData,
            isGovernmentInsurance: isGovernmentInsurance,
            potentialBookingValue: costPlanValue,
            stateCode: stateCode,
        });
    }
}
